import Page from '../../components/shared/Page/Page';
import StyledContentLayout from '../../styles/StyledContentLayout';
import { consultationPackagePlan } from '../../config/billingPlansConfig';
import PricingCardsCarousel from '../../components/pricing/PricingCardsCarousel';
import PricingCard from '../../components/pricing/PricingCard';
import useAuth from '../../hooks/useAuth';

const HelpPricing: React.FC = () => {
  const { currentUser } = useAuth();

  return (
    <Page title="Elora | Help Pricing">
      <StyledContentLayout wide>
        <PricingCardsCarousel>
          <PricingCard
            key={consultationPackagePlan.id}
            plan={consultationPackagePlan}
            currentUser={currentUser}
          />
        </PricingCardsCarousel>
      </StyledContentLayout>
    </Page>
  );
};

export default HelpPricing;
